import React, { FunctionComponent } from 'react'
import Svg, { Rect } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

/**
 * Pause button on top of thumbnail
 */
export const ThumbnailPauseIcon: FunctionComponent<ThumbnailPauseIconProps> = ({ size = 64, fillColor }) => {
  const { colors } = useTheme()
  const iconFillColor = fillColor ? fillColor : colors.textDarkBackground

  return (
    <Svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill='none'>
      <Rect x='23' y='18' width='7' height='28' fill={iconFillColor} />
      <Rect x='35' y='18' width='7' height='28' fill={iconFillColor} />
    </Svg>
  )
}

type ThumbnailPauseIconProps = {
  size?: string | number
  fillColor?: string
}
